import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledWidgetsHero = styled.section`
	color: ${CSSVars.gray900};
	text-align: center;
	overflow: hidden;
	background: url(/assets/hero-bg.webp);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center 0%;
	color: ${CSSVars.white};

	.hero-wrapper {
		padding: 80px 20px 50px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 130px 40px 100px;
		}

		h1 {
			z-index: 10;
			margin: 0 auto;
			margin-bottom: 20px;
			font-size: ${CSSVars.fontSize2XL};
			text-align: left;
			max-width: 800px;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize3XL};
			}
		}

		h2 {
			z-index: 10;
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			text-align: left;
			max-width: 500px;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				text-align: center;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				max-width: 670px;
				font-size: ${CSSVars.fontSizeXL};
			}
		}
	}
`;
